/**
 * The languages a sales document may be written in.
 *
 * The LIST comes from the server (`GET /admin/crm/numbering` -> `docLocales`)
 * and is not repeated here. It is a property of the PDF renderer's font rather
 * than of this screen, so a copy on the client would be a second answer that
 * goes stale the day somebody embeds a Unicode font.
 *
 * The NAMES are the platform's one language picker's (`LocaleCombobox` in
 * @wa/ui): the language's own name, and the reader's name for it as the hint,
 * so an operator working in Estonian still finds German by typing "saksa".
 */

/** Mirrors the server's default, for the moment before the first load answers. */
export const FALLBACK_DOC_LOCALES = ["et", "en"];
